console.log("🚀 Uploadery XOR External Link (SAFE v2) cargado");

(function () {
  const EXTERNAL_VISIBLE_ID = "external_link";
  const EXTERNAL_HIDDEN_ID = "external_link_hidden";

  // Si tenés el ID exacto del app block, ponelo acá (si cambia, el script igual busca fallback)
  const UPLOADERY_BLOCK_ID = "shopify-block-AY0VWUVVRcXZ5akUxV__uploadery_app_block_8xDYYQ";

  function findUploaderyContainer(uploaderyForm) {
    // 1) Intentar con el ID fijo (si existe)
    const byId = document.getElementById(UPLOADERY_BLOCK_ID);
    if (byId) return byId;

    // 2) Subir algunos niveles buscando algo que “huela” a Uploadery block
    let el = uploaderyForm;
    for (let i = 0; i < 8 && el; i++) {
      const id = (el.id || "").toLowerCase();
      const cls = (el.className || "").toString().toLowerCase();
      if (id.includes("uploadery") || id.includes("app_block") || cls.includes("uploadery")) return el;
      el = el.parentElement;
    }

    // 3) Fallback: el propio form
    return uploaderyForm;
  }

  function setUploaderyEnabled(uploaderyContainer, enabled) {
    if (!uploaderyContainer) return;

    // Deshabilitar SOLO inputs/file/buttons dentro del contenedor Uploadery
    uploaderyContainer.querySelectorAll("input[type='file'], button, label").forEach((el) => {
      // label no tiene disabled, pero sí pointer events
      if (el.tagName.toLowerCase() === "label") {
        el.style.pointerEvents = enabled ? "" : "none";
        el.style.opacity = enabled ? "" : "0.5";
        el.setAttribute("aria-disabled", enabled ? "false" : "true");
      } else {
        // input file o button
        el.disabled = !enabled;
      }
    });
  }

  function setUploaderyVisible(uploaderyContainer, visible) {
    if (!uploaderyContainer) return;
    uploaderyContainer.style.display = visible ? "" : "none";
  }

  function setExternalEnabled(externalInputVisible, externalInputHidden, enabled) {
    externalInputVisible.disabled = !enabled;
    externalInputHidden.disabled = !enabled;

    // No borramos el valor automáticamente al deshabilitar (para no perder lo que escribió),
    // solo lo bloqueamos. Si querés borrarlo, decime y lo ajusto.
    externalInputVisible.style.opacity = enabled ? "" : "0.6";
  }

  function init() {
    const uploaderyForm = document.querySelector("[data-uploadery]");
    const productForm = document.querySelector("form[data-type='add-to-cart-form']");
    const externalInputVisible = document.getElementById(EXTERNAL_VISIBLE_ID);

    if (!uploaderyForm || !productForm || !externalInputVisible) {
      console.warn("⚠️ Falta Uploadery o form o external_link. Reintentando...");
      return false;
    }

    // hidden input para mandar la propiedad a Shopify
    let externalInputHidden = document.getElementById(EXTERNAL_HIDDEN_ID);
    if (!externalInputHidden) {
      externalInputHidden = document.createElement("input");
      externalInputHidden.type = "hidden";
      externalInputHidden.name = "properties[External Link]";
      externalInputHidden.id = EXTERNAL_HIDDEN_ID;
      externalInputHidden.value = "";
      productForm.appendChild(externalInputHidden);
    }

    const uploaderyContainer = findUploaderyContainer(uploaderyForm);

    // Bandera para distinguir si data-uploadery-valid=true es “real” o forzado por link
    const isLinkMode = () => (uploaderyForm.dataset.externalLinkMode || "") === "true";

    const hasRealUpload = () => {
      const valid = (uploaderyForm.getAttribute("data-uploadery-valid") || "").toLowerCase() === "true";
      return valid && !isLinkMode();
    };

    function enterLinkMode() {
      uploaderyForm.dataset.externalLinkMode = "true";

      // Permitimos add-to-cart aunque no haya upload
      if (!uploaderyForm.dataset.prevUploaderyValidSaved) {
        uploaderyForm.dataset.prevUploaderyValid = uploaderyForm.getAttribute("data-uploadery-valid") || "";
        uploaderyForm.dataset.prevUploaderyValidSaved = "true";
      }
      uploaderyForm.setAttribute("data-uploadery-valid", "true");

      // OCULTAR Uploadery (como querías) + además deshabilitar el input file por seguridad
      setUploaderyVisible(uploaderyContainer, false);
      setUploaderyEnabled(uploaderyContainer, false);

      // Link habilitado
      setExternalEnabled(externalInputVisible, externalInputHidden, true);
    }

    function exitLinkMode() {
      uploaderyForm.dataset.externalLinkMode = "";

      // Restaurar el data-uploadery-valid previo (para no “engañar” al sistema)
      if (uploaderyForm.dataset.prevUploaderyValidSaved === "true") {
        const prev = uploaderyForm.dataset.prevUploaderyValid || "";
        if (prev === "") uploaderyForm.removeAttribute("data-uploadery-valid");
        else uploaderyForm.setAttribute("data-uploadery-valid", prev);
        delete uploaderyForm.dataset.prevUploaderyValid;
        delete uploaderyForm.dataset.prevUploaderyValidSaved;
      }

      // Mostrar Uploadery y re-habilitarlo
      setUploaderyVisible(uploaderyContainer, true);
      setUploaderyEnabled(uploaderyContainer, true);

      // Link habilitado (a menos que haya upload real)
      setExternalEnabled(externalInputVisible, externalInputHidden, true);
    }

    function applyState() {
      const linkVal = (externalInputVisible.value || "").trim();
      externalInputHidden.value = linkVal;

      // Si hay upload real, bloqueamos el link (para que no manden ambas cosas)
      if (hasRealUpload()) {
        exitLinkMode(); // por si veníamos de link mode
        setExternalEnabled(externalInputVisible, externalInputHidden, false);
        return;
      }

      // Si hay link escrito => modo link (oculta uploadery)
      if (linkVal !== "") {
        enterLinkMode();
        return;
      }

      // Si no hay nada => estado normal
      exitLinkMode();
    }

    // Evento: escribir/borrar link
    externalInputVisible.addEventListener("input", applyState);

    // Observer: Uploadery cambia valid cuando suben/quitan archivo
    const obs = new MutationObserver(() => {
      // si estamos en link mode, ignoramos (porque el "true" es forzado)
      if (isLinkMode()) return;
      applyState();
    });
    obs.observe(uploaderyForm, { attributes: true, attributeFilter: ["data-uploadery-valid"] });

    // Validación final al submit: bloquear si quedan ambas (por algún edge)
    function validate(e) {
      const linkVal = (externalInputVisible.value || "").trim();
      const hasLink = linkVal !== "";
      const upload = hasRealUpload();

      if (hasLink && !/^https:\/\/.+/i.test(linkVal)) {
        e.preventDefault();
        alert("Please enter a valid link beginning with https://");
        externalInputVisible.focus();
        return false;
      }

      if (hasLink && upload) {
        e.preventDefault();
        alert("Please provide EITHER an Upload OR an External Link (not both).");
        return false;
      }

      return true;
    }
    productForm.addEventListener("submit", validate);

    // Estado inicial
    applyState();

    console.log("✅ XOR SAFE v2 listo. Container:", uploaderyContainer);
    return true;
  }

  let tries = 0;
  const t = setInterval(() => {
    tries++;
    if (init() || tries > 15) clearInterval(t);
  }, 600);
})();
